// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__button___DbIyi {
    border-radius: 40px;
    align-self: center;
    /*border-color: var(--black);*/
    padding: 0;
    justify-content: center;
    align-items: center;
    width: 520px;
    height: 48px;
    margin-top: 2vh;
}

@media screen and (max-width: 1100px) {
    .style__button___DbIyi {
        width: 90vw;
    }
}

.style__text___xjZcS {
    text-align: center;
    color: #fff;
    font-size: 18px;
}

.style__colored___Tw4vX {
    background: linear-gradient(to right, var(--secondaryB-color), var(--secondaryA-color));
}

.style__black___njFpe {
    background-color: var(--black);
}

.style__innerContainer___o78Rr {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Buttons/Button/style.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".button {\n    border-radius: 40px;\n    align-self: center;\n    /*border-color: var(--black);*/\n    padding: 0;\n    justify-content: center;\n    align-items: center;\n    width: 520px;\n    height: 48px;\n    margin-top: 2vh;\n}\n\n@media screen and (max-width: 1100px) {\n    .button {\n        width: 90vw;\n    }\n}\n\n.text {\n    text-align: center;\n    color: #fff;\n    font-size: 18px;\n}\n\n.colored {\n    background: linear-gradient(to right, var(--secondaryB-color), var(--secondaryA-color));\n}\n\n.black {\n    background-color: var(--black);\n}\n\n.innerContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `style__button___DbIyi`,
	"text": `style__text___xjZcS`,
	"colored": `style__colored___Tw4vX`,
	"black": `style__black___njFpe`,
	"innerContainer": `style__innerContainer___o78Rr`
};
export default ___CSS_LOADER_EXPORT___;
